export default __webpack_public_path__ + "static/media/fastFood03.80332343.png";